// Native selectors in the reviewed old Composer arrangement. No synthetic
// default option is selectable; unknown current values use a placeholder.
import { useState } from 'react'
import { modelGroups } from './models'
import { concrete } from './choices'
import type { Choice } from './choices'
export function ChoiceSelect({label, value, choices, disabled = false, missing, onChange}: {
  label: string
  value: string | null
  choices: readonly Choice[]
  disabled?: boolean
  missing?: string
  onChange(value: string): void
}) {
  const [opened, setOpened] = useState(false)
  const known = label === 'Mode' ? value ?? '' : concrete(value) ? value : ''
  const held = known && !choices.some(choice => choice.id === known) ? {id: known, label: known} : null
  const groups = modelGroups(choices)
  const shown = label === 'Model' ? [...groups.latest, ...(opened ? groups.older : groups.older.filter(choice => choice.id === known))] : choices
  const older = '__poulpe_older_models__'
  return <select aria-label={label} value={known} disabled={disabled} onChange={event => {if (label === 'Model' && event.target.value === older) {setOpened(!opened);event.target.value = known} else if (choices.some(choice => choice.id === event.target.value && !choice.disabled)) onChange(event.target.value)}}>
    {!known && <option value="" disabled>{missing ?? (label === 'Model' ? 'Choose a model' : label === 'Effort' ? 'Choose effort' : 'Choose mode')}</option>}
    {held && <option value={held.id} disabled>{held.label}</option>}
    {shown.map(choice => <option value={choice.id} key={choice.id} disabled={choice.disabled}>{choice.label}</option>)}
    {label === 'Model' && groups.older.length > 0 && <option value={older}>{opened ? 'Latest models' : 'Older models'}</option>}
  </select>
}
export function Picker(props: Parameters<typeof ChoiceSelect>[0]) {
  return <label className="code-picker"><span className="code-picker-name">{props.label}</span><ChoiceSelect {...props}/></label>
}
